export default __webpack_public_path__ + "static/media/icon-big-consegna-88-px.25e0e221.svg";